import { Popover } from 'bootstrap';
import { createApp } from 'vue';

// Shared state to track active popover
let activePopover = null;
let clickOutsideHandler = null;
let popoverCount = 0;

const addClickOutsideHandler = () => {
    if (!clickOutsideHandler) {
        clickOutsideHandler = (e) => {
            if (activePopover) {
                const clickedElement = e.target;
                const isInsidePopover = clickedElement.closest('.popover') ||
                                      clickedElement.closest('[data-bs-toggle="popover"]');

                if (!isInsidePopover) {
                    activePopover.hide();
                    activePopover = null;
                }
            }
        };
        document.addEventListener('click', clickOutsideHandler);
    }
};

const removeClickOutsideHandler = () => {
    if (clickOutsideHandler && popoverCount <= 0) {
        document.removeEventListener('click', clickOutsideHandler);
        clickOutsideHandler = null;
        activePopover = null;
    }
};

export const popoverDirective = {
    mounted(el, binding) {
        const isComponent = binding.value && typeof binding.value === 'object' && binding.value.component;
        const isPlainOptions = !isComponent && binding.value && typeof binding.value === 'object' && !Array.isArray(binding.value);

        const options = {
            content: isComponent
                ? '<div class="popover-content-placeholder"></div>'
                : isPlainOptions
                    ? (binding.value.content || '')
                    : (typeof binding.value === 'string' ? binding.value : (el.getAttribute('data-bs-content') || '')),
            title: (isPlainOptions ? binding.value.title : null) || el.getAttribute('data-bs-title') || '',
            placement: (isPlainOptions ? binding.value.placement : null) || binding.arg || el.getAttribute('data-bs-placement') || 'top',
            trigger: (isPlainOptions ? binding.value.trigger : null) || el.getAttribute('data-bs-trigger') || 'click',
            html: isPlainOptions ? (binding.value.html !== false) : true,
            delay: el.getAttribute('data-bs-delay') ? parseInt(el.getAttribute('data-bs-delay')) : 0,
            sanitize: false
        };

        const popover = new Popover(el, options);

        el._popover = popover;
        el._popoverComponent = isComponent ? binding.value : null;

        el.addEventListener('shown.bs.popover', () => {
            if (activePopover && activePopover !== popover) {
                activePopover.hide();
            }
            activePopover = popover;

            if (isComponent) {
                const popoverBody = popover.tip.querySelector('.popover-content-placeholder');
                if (popoverBody) {
                    const app = createApp(binding.value.component, {
                        ...binding.value.props,
                        onCopyAddress: binding.value.onCopyAddress
                    });

                    el._popoverApp = app;
                    el._popoverComponent = app.mount(popoverBody);

                    setTimeout(() => {
                        popover.update();
                    }, 0);
                }
            }
        });

        el.addEventListener('hidden.bs.popover', () => {
            if (activePopover === popover) {
                activePopover = null;
            }

            if (el._popoverApp) {
                el._popoverApp.unmount();
                el._popoverApp = null;
                el._popoverComponent = null;
            }
        });

        popoverCount++;
        addClickOutsideHandler();
    },
    updated(el, binding) {
        if (el._popover && binding.value !== binding.oldValue) {
            const isComponent = binding.value && typeof binding.value === 'object' && binding.value.component;
            const isPlainOptions = !isComponent && binding.value && typeof binding.value === 'object' && !Array.isArray(binding.value);
            const content = isComponent
                ? '<div class="popover-content-placeholder"></div>'
                : isPlainOptions
                    ? (binding.value.content || '')
                    : (typeof binding.value === 'string' ? binding.value : '');
            el._popover.setContent({ '.popover-body': content });
        }
    },
    beforeUnmount(el) {
        if (el._popover) {
            if (activePopover === el._popover) {
                activePopover = null;
            }

            // Unmount Vue component if it exists
            if (el._popoverApp) {
                el._popoverApp.unmount();
                el._popoverApp = null;
                el._popoverComponent = null;
            }

            el._popover.dispose();
            delete el._popover;
        }

        popoverCount--;
        removeClickOutsideHandler();
    }
};

// Cleanup function to remove global event listener (for manual use if needed)
export const cleanupPopover = () => {
    if (clickOutsideHandler) {
        document.removeEventListener('click', clickOutsideHandler);
        clickOutsideHandler = null;
        activePopover = null;
        popoverCount = 0;
    }
};
